/**
 * Mirrors Go stripWordPunct / Python engine regex.
 * Strips leading and trailing non-word characters; preserves hyphen and apostrophe inside words.
 */
export function stripWordPunctuation(s) {
  return s.replace(/^[^\w\u0027-]+|[^\w\u0027-]+$/g, '')
}
